import React from "react";
import { Col } from "react-bootstrap";

interface SummaryLabelProps {
  label: string;
  value: React.ReactNode;
}
const SummaryLabel: React.FC<SummaryLabelProps> = ({ label, value }) => {
  return (
    <>
      <Col md={2}>
        <strong>{label}</strong>
      </Col>
      <Col md={4}>{value}</Col>
    </>
  );
};

export default SummaryLabel;
